import { createContext, FC } from 'react'

export const LifeStoriesContext = createContext<true | false>(false)

export const LifeStoriesContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <LifeStoriesContext.Provider value={true}>{children}</LifeStoriesContext.Provider>
)
